import { useEffect } from 'react';

/**
 * Custom hook to set the page title for SEO and browser tab display
 * @param title - The page-specific title (e.g., "Market Detail", "Favorites")
 * @param suffix - Optional suffix, defaults to "HTL Market Insights"
 */
export const usePageTitle = (title: string, suffix: string = 'HTL Market Insights') => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | ${suffix}` : suffix;

    // Cleanup: restore previous title on unmount
    return () => {
      document.title = previousTitle;
    };
  }, [title, suffix]);
};
